import { FC } from 'react';

import CapsulePriceEditComponent from 'components/main/CapsulePrice/Edit';

const CapsulePriceEdit: FC = () => <CapsulePriceEditComponent />;

export default CapsulePriceEdit;
